import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ maxWidth: 720, margin: "4rem auto", textAlign: "center" }}>
      <h1 style={{ marginBottom: 8 }}>Página no encontrada</h1>
      <p style={{ color: "#666" }}>
        La ruta que intentaste abrir no existe o cambió.
      </p>
      <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 16 }}>
        <Link className="btn btn-outline-secondary" to="/inicio">Ir a Inicio Estudiantes</Link>
        <Link className="btn btn-primary" to="/">Ir a Inicio Funcionarios</Link>
      </div>
    </div>
  );
}
